(function () {
    'use strict';
    angular.module('ib-alert-notification-module', []);
})();